export enum IClientFormFields {
	formalName = 'formalName',
	shortName = 'shortName',
	domainName = 'domainName',
	website = 'website',
	color = 'color',
	logo = 'logo',
	organizationIsicCode = 'organizationIsicCode',
	comment = 'comment',
	mailingListKey = 'mailingListKey',
	contractStartDate = 'contractStartDate',
	contractEndDate = 'contractEndDate',
	integrationId = 'integrationId',
	contract = 'contract',
	clientUserCountLimit = 'clientUserCountLimit',
	limitPerClientId = 'limitPerClientId',
	surveyCountLimit = 'surveyCountLimit',
	shouldDelete = 'shouldDelete',
	shouldUpdate = 'shouldUpdate',
}
